import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-circleFinish",
  "use": "icon-circleFinish-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-circleFinish\"><defs><style type=\"text/css\"></style></defs><path d=\"M514 961C267.681 961 68 761.319 68 515S267.681 69 514 69s446 199.681 446 446-199.681 446-446 446z m0-60c213.182 0 386-172.818 386-386S727.182 129 514 129 128 301.818 128 515s172.818 386 386 386z\" p-id=\"8052\" /><path d=\"M740.145 338l42.427 42.426-316.077 316.077-42.426-42.426z\" p-id=\"8053\" /><path d=\"M242 509.802l42.426-42.427 205.768 205.769-42.426 42.426z\" p-id=\"8054\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/circleFinish.svg
// module id = GJnQ
// module chunks = 25